import { justificacion, objetivo, tipo } from "./communsDescriptors";
import { ueDescriptor } from "./ueDescriptor";

export const proyectoDescriptor =
    [
        justificacion,
        objetivo,
        ueDescriptor,
        tipo
    ];